import { render, staticRenderFns } from "./CardPostulacion.vue?vue&type=template&id=ed455910&scoped=true"
import script from "./CardPostulacion.vue?vue&type=script&lang=js"
export * from "./CardPostulacion.vue?vue&type=script&lang=js"
import style0 from "./CardPostulacion.vue?vue&type=style&index=0&id=ed455910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed455910",
  null
  
)

export default component.exports